import fontThin from '../assets/fonts/Inter-Thin.ttf';
import fontLight from '../assets/fonts/Inter-Light.ttf';
import fontRegular from '../assets/fonts/Inter-Regular.ttf';
import fontMedium from '../assets/fonts/Inter-Medium.ttf';
import fontSemiBold from '../assets/fonts/Inter-SemiBold.ttf';
import fontBold from '../assets/fonts/Inter-Bold.ttf';
import fontExtraBold from '../assets/fonts/Inter-ExtraBold.ttf';

export const MuiCssBaseline = {
  styleOverrides: `
      html { font-size: 14px; }
      @font-face {
          font-family: 'fontThin';
          font-style: normal;
          font-display: swap;
          font-weight: 100;
          src: local('Inter'), local('Inter-Thin'), url(${fontThin}) format('trueType');
      }
      @font-face {
          font-family: 'fontLight';
          font-style: normal;
          font-display: swap;
          font-weight: 300;
          src: local('Inter'), local('Inter-Light'), url(${fontLight}) format('trueType');
      }
      @font-face {
          font-family: 'fontRegular';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Inter'), local('Inter-Regular'), url(${fontRegular}) format('trueType');
      }
      @font-face {
          font-family: 'fontMedium';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('Inter'), local('Inter-Medium'), url(${fontMedium}) format('trueType');
      }
      @font-face {
          font-family: 'fontSemiBold';
          font-style: normal;
          font-display: swap;
          font-weight: 600;
          src: local('Inter'), local('Inter-SemiBold'), url(${fontSemiBold}) format('trueType');
      }
      @font-face {
          font-family: 'fontBold';
          font-style: normal;
          font-display: swap;
          font-weight: 700;
          src: local('Inter'), local('Inter-Bold'), url(${fontBold}) format('trueType');
      }
      @font-face {
          font-family: 'fontExtraBold';
          font-style: normal;
          font-display: swap;
          font-weight: 800;
          src: local('Inter'), local('Inter-ExtraBold'), url(${fontExtraBold}) format('trueType');
      }
      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[type='number'] {
        -moz-appearance: textfield;
      }
    `,
};

export const FONT = {
  w100: 'fontThin',
  w300: 'fontLight',
  w400: 'fontRegular',
  w500: 'fontMedium',
  w600: 'fontSemiBold',
  w700: 'fontBold',
  w800: 'fontExtraBold',
};

export const FONT_CATEGORIES = {
  CATEGORY_A: [
    {
      table: {
        tableTitle: 14,
        tableColumnHeader: 12,
        tableContent: 12,
      },
      page: {
        pageTitle: 16,
        pageSubtitle: 14,
        pageContent: 12,
      },
      form: {
        formTitle: 14,
        formLabel: 12,
        formContent: 12,
      },
      button: {
        buttonLabel: 14,
      },
      tooltip: {
        tooltipContent: 10,
      },
      modal: {
        modalTitle: 14,
        modalContent: 12,
      },
      drawer: {
        drawerTitle: 14,
        drawerContent: 12,
      },
    },
  ],
  CATEGORY_AA: [
    {
      table: {
        tableTitle: 16,
        tableColumnHeader: 14,
        tableContent: 12,
      },
      page: {
        pageTitle: 18,
        pageSubtitle: 16,
        pageContent: 14,
      },
      form: {
        formTitle: 16,
        formLabel: 14,
        formContent: 12,
      },
      button: {
        buttonLabel: 16,
      },
      tooltip: {
        tooltipContent: 12,
      },
      modal: {
        modalTitle: 16,
        modalContent: 14,
      },
      drawer: {
        drawerTitle: 16,
        drawerContent: 14,
      },
    },
  ],
  CATEGORY_AAA: [
    {
      table: {
        tableTitle: 18,
        tableColumnHeader: 16,
        tableContent: 14,
      },
      page: {
        pageTitle: 20,
        pageSubtitle: 18,
        pageContent: 16,
      },
      form: {
        formTitle: 18,
        formLabel: 16,
        formContent: 14,
      },
      button: {
        buttonLabel: 18,
      },
      tooltip: {
        tooltipContent: 14,
      },
      modal: {
        modalTitle: 18,
        modalContent: 16,
      },
      drawer: {
        drawerTitle: 18,
        drawerContent: 16,
      },
    },
  ],
};
